import {merge} from '#core/utils/config-utils.js';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {getBaseComponentsConfig} from './style/base-components';
import {getMyAccountConfigs} from './style/account';
import {getMenuListsConfigs} from './style/menus-links-lists';
import {getBetHistoryConfigs} from './style/bethistory';
import {getBettingCenterConfig} from './style/betting-center';
import {getBonusesConfig} from './style/bonuses';
import {getCardsConfigs} from './style/cards';
import {getDialogsConfigs} from './style/dialogs';
import {getMarketsConfigs} from './style/markets';
import {getMatchAccaConfigs} from './style/matchacca';
import {getPageHeadersConfigs} from './style/interface';
import {getRacingConfigs} from './style/racing';
import {getStaticPagesConfigs} from './style/static-pages';
import {getVirtualsConfigs} from './style/virtuals';
import {getSportsContentConfigs} from './style/sports-content';
import {COLOR, FONT} from './theme.js';

export function getTokens() {
    const viewsConfig = {
        SlidingBetslipController: {
            standardBetslip: {
                view: {
                    slidingPane: {
                        style: {
                            borderTop: `4px solid ${COLOR.BRAND.CTA1}`,
                        },
                    },
                },
            },
            quickBetslip: {
                view: {
                    slidingPane: {
                        style: {
                            borderTop: `4px solid ${COLOR.BRAND.CTA1}`,
                        },
                    },
                },
            },
        },
        SportsMenuView: {
            itemContainer: {
                style: {
                    fontSize: FONT.SIZE_MEDIUM,
                },
            },
        },
    };

    const tokens = merge(
        {
            custom: {
                [PALETTE_IDS.APP_VIEW]: viewsConfig,
            },
            palette: {
                [PALETTE_IDS.FONT]: FONT,
                [PALETTE_IDS.APP_VIEW]: {
                    BACK_TO_TOP_BUTTON: {
                        TERTIARY_BUTTON_TEXT: {
                            fontWeight: FONT.WEIGHT_NORMAL,
                            color: COLOR.BRAND.FOREGROUND1,
                            textTransform: 'capitalize',
                        },
                    },
                    ACCA_BAR_BORDER_COLOR: COLOR.BRAND.ACCENT1,
                    ACCA_BAR_LABEL_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },
                [PALETTE_IDS.MOBILE_NAVBAR]: {
                    CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    LABEL_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                    },
                },
                [PALETTE_IDS.INPUT]: {
                    INPUT_BG: COLOR.BRAND.BACKGROUND1,
                    INPUT_TEXT: COLOR.BRAND.FOREGROUND1,
                    INPUT_PLACEHOLDER_TEXT: COLOR.BRAND.FOREGROUND1,
                    INPUT_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
                    INPUT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                    INPUT_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                    INPUT_FOCUSED_BORDER_COLOR: COLOR.BRAND.ACCENT3,
                },
                [PALETTE_IDS.STAKE_INPUT]: {
                    STAKE_INPUT_BG: COLOR.BRAND.BACKGROUND1,
                    STAKE_INPUT_TEXT: COLOR.BRAND.FOREGROUND1,
                    STAKE_INPUT_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                    STAKE_INPUT_FOCUSED_BORDER_COLOR: COLOR.BRAND.ACCENT3,
                },
                [PALETTE_IDS.RANGE_INPUT]: {
                    RANGE_TRACK_COLOR: COLOR.BRAND.BACKGROUND4,
                    RANGE_TRACK_FILLED_COLOR: COLOR.BRAND.BACKGROUND3,
                    RANGE_THUMB_COLOR: COLOR.BRAND.BACKGROUND3,
                    RANGE_TRACK_DISABLED_COLOR: COLOR.BRAND.FOREGROUND4,
                    RANGE_THUMB_DISABLED_COLOR: COLOR.BRAND.FOREGROUND4,
                    RANGE_TRACK_DISABLED_FILLED_COLOR: COLOR.BRAND.FOREGROUND4,
                    RANGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                [PALETTE_IDS.SEARCH_RESULT]: {
                    SEARCH_RESULT_ITEM_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                    SEARCH_RESULT_ITEM_TOURNAMENT_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontSize: FONT.SIZE_XSMALL,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    SEARCH_RESULT_ITEM_NAME_TEXT: {
                        fontWeight: FONT.WEIGHT_NORMAL,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    SEARCH_RESULT_ITEM_STATUS_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontSize: FONT.SIZE_XSMALL,
                    },

                    SEARCH_RECENT_ITEM_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                    SEARCH_RECENT_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
                    SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                },
                [PALETTE_IDS.SWITCH]: {
                    SWITCH_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    SWITCH_CONTAINER_BORDER_COLOR: COLOR.BRAND.BACKGROUND6,
                    SWITCH_BUTTON_BG: COLOR.BRAND.BACKGROUND3,
                    SWITCH_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                    SWITCH_DISABLED_CONTAINER_BORDER_COLOR: COLOR.BRAND.BACKGROUND5,
                    SWITCH_DISABLED_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                    SWITCH_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
                },
                [PALETTE_IDS.ERROR_NOTIFICATION]: {
                    ERROR_BG: COLOR.SEMANTIC.ERROR2,
                    ERROR_BORDER_COLOR: COLOR.SEMANTIC.ERROR1,
                },
                [PALETTE_IDS.INFO_NOTIFICATION]: {
                    INFO_BG: COLOR.BRAND.BACKGROUND4,
                    INFO_BORDER_COLOR: 'transparent',
                    INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                    INFO_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                },
                [PALETTE_IDS.SUCCESS_NOTIFICATION]: {
                    SUCCESS_BG: 'transparent',
                    SUCCESS_TEXT: COLOR.BRAND.FOREGROUND1,
                    SUCCESS_BORDER_COLOR: COLOR.SEMANTIC.SUCCESS1,
                    SUCCESS_ICON_COLOR: COLOR.SEMANTIC.SUCCESS1,
                },
                [PALETTE_IDS.WARNING_NOTIFICATION]: {
                    WARNING_BG: COLOR.SEMANTIC.WARNING1,
                },
                [PALETTE_IDS.SKELETON]: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND7,
                },
                [PALETTE_IDS.EMPTY_CONTENT_MESSAGE]: {
                    EMPTY_CONTENT_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND2,
                    LINK: {
                        SECONDARY_LINK_TEXT: {
                            color: COLOR.BRAND.ACCENT1,
                            fontWeight: FONT.WEIGHT_NORMAL,
                        },
                    },
                },
                [PALETTE_IDS.CHANGED_VALUE_INDICATOR]: {
                    CVI_INDICATION_ICON_COLOR: COLOR.BRAND.ACCENT1,
                    CVI_PREVIOUS_VALUE_TEXT: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND1}`,
                    CVI_NEW_VALUE_BG: COLOR.SEMANTIC.WARNING2,
                    CVI_NEW_VALUE_TEXT: {
                        color: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND1}`,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },
                [PALETTE_IDS.CUSTOM_PAGE]: {
                    MAIN_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                },
                [PALETTE_IDS.SCOREBOARDS]: {
                    SCOREBOARD_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
                    ACCENT_COLOR: COLOR.BRAND.ACCENT1,
                    SCORE_TEXT: COLOR.BRAND.ACCENT1,

                    SEGMENT_TOTAL_HEADER_TEXT: COLOR.BRAND.ACCENT1,
                    SEGMENT_TOTAL_TEXT: COLOR.BRAND.ACCENT1,
                    // No possibility to specify server indicator color - moj limitation
                    TEAM_SEPARATOR_COLOR: COLOR.BRAND.FOREGROUND2,
                },
                [PALETTE_IDS.BET_SHARING_DIALOG]: {
                    BET_SHARING_CONTENT_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,
                },
            },
        },
        getBaseComponentsConfig(),
        getMyAccountConfigs(),
        getMenuListsConfigs(),
        getBetHistoryConfigs(),
        getBettingCenterConfig(),
        getBonusesConfig(),
        getCardsConfigs(),
        getDialogsConfigs(),
        getMarketsConfigs(),
        getMatchAccaConfigs(),
        getPageHeadersConfigs(),
        getRacingConfigs(),
        getStaticPagesConfigs(),
        getVirtualsConfigs(),
        getSportsContentConfigs()
    );

    return tokens;
}
